import React, { Component } from 'react';
import { Link } from 'react-router-dom';

import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import IconButton from '@material-ui/core/IconButton';
import InputAdornment from '@material-ui/core/InputAdornment';
import MenuItem from '@material-ui/core/MenuItem';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import TextField from '@material-ui/core/TextField';

import { toast, ToastContainer } from 'react-toastify';
import moment from 'moment/moment';
import NumberFormat from 'react-number-format';
import queryString from 'query-string';

import Api from '../../../libraries/api';
import AuthHelper from '../../../libraries/auth-helper';
import TablePaginationActions from '../../presentational/table-pagination-actions';
import { history } from '../../../shared/configure-store';
import image from '../../../images/product.png';

require('dotenv').config();

class Products extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            loadingButton: false,
            showDialog: false,
            active: true,
            errors: {},
            cat: '',
            sub: '',
            productSegment: '',
            searchBy: '',
            orderBy: 'id',
            sortedBy: '',
            categories: [],
            subcategories: [],
            rows: [],
            total: 0,
            perPage: 20,
            currentPage: 0,
            nextPage: 0,
            currentPageTable: 0,
            isManage: false,
        };
        this.handleChange = this.handleChange.bind(this);
    }

    componentDidMount() {
        document.title = 'Gudangemas - Produk';
        const profile = AuthHelper.getProfile();
        const urlParams = queryString.parse(this.props.location.search);

        if (profile['map-menu']) {
            const roles = profile['map-menu']
                .map(o => ({ id: o.id, name: o.menu.name, isCreate: o.isCreate, isManage: o.isManage }))
                .filter(item => item.name === 'Daftar Produk');

            if (roles.length > 0) {
                this.setState({ isManage: roles[0].isManage });
            }
        }

        Api.get('/product-category/all-active').then(resp => this.setState({ categories: resp.data, loading: false }));

        Api.get('/product-sub-category/all-active').then(resp => this.setState({ subcategories: resp.data, loading: false }));

        if (urlParams) {
            this.setState(
                {
                    cat: urlParams.cat || '',
                    sub: urlParams.sub || '',
                    productSegment: urlParams.productSegment || '',
                    searchBy: urlParams.s || '',
                },
                () => {
                    if (this.state.cat) this.__fetchSub();
                    this.__fetchData(true);
                }
            );
        } else {
            this.__fetchData(false);
        }
    }

    __fetchData = (update) => {
        this.setState({ loading: true });

        const { cat, sub, productSegment, searchBy, orderBy, sortedBy, currentPage, perPage } = this.state;
        const params = {
            page: update ? 0 : currentPage,
            size: perPage,
            sort: [{ 'column-name': orderBy, 'is-ascending': sortedBy === 'asc' }],
        };

        if (searchBy) params['search-by'] = searchBy;
        if (cat) params['category-id'] = cat;
        if (sub) params['sub-category-id'] = sub;
        if (productSegment) params['product-segment'] = productSegment;

        Api.post('/product/view', params)
            .then((resp) => {
                const now = moment();
                const products = resp.data.viewProducts.map((o) => {
                    const start = moment(o['sale-start-date'], 'DD/MM/YYYY');
                    const end = moment(o['sale-end-date'], 'DD/MM/YYYY');

                    return {
                        id: o.id,
                        sku: o.sku,
                        image: o.image,
                        stock: parseFloat(o.stock),
                        rating: parseFloat(o.rating),
                        weight: o.weight,
                        isActive: o.isActive,
                        idProduct: o['id-product'],
                        category: o['category-name'],
                        sub: o['sub-catgeory-name'],
                        name: o['product-name'],
                        price: o['regular-price'],
                        productType: o['product-type-name'],
                        priceSale: o['sale-price'],
                        isSale: moment(now).isBetween(start, end),
                        startSale: o['sale-start-date'],
                        endSale: o['sale-end-date'],
                        quantity: 0,
                    };
                });

                this.setState({
                    rows: products,
                    total: resp.data.totalItems,
                    currentPageTable: resp.data.currentPage,
                    currentPage: resp.data.currentPage,
                    nextPage: resp.data.currentPage + 1,
                    loading: false,
                });
            })
            .catch((err) => this.setState({ errors: err, loading: false }));
    };

    __fetchSub = () => {
        Api.get(`/product-sub-category/category-id/${this.state.cat}`)
        .then((resp) => this.setState({ subcategories: resp.data, loading: false }));
    };

    showMessage = (status, message) => toast[status ? 'success' : 'error'](message, { position: toast.POSITION.BOTTOM_RIGHT });

    handleGo = (link) => history.push(link);

    handleSearch = () => this.__fetchData(true);

    handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            this.__fetchData(true);
        }
    };

    handleChangePage = (_, newPage) => {
        this.setState({ rows: [], currentPage: newPage, currentPageTable: newPage, loading: true }, () => this.__fetchData(false));
    }

    handleChangeRowsPerPage = (e) => {
        this.setState({ perPage: parseInt(e.target.value, 10), currentPage: 1, loading: true }, () => this.__fetchData(false));
    }

    handleSort = (val) => {
        const { sortedBy } = this.state;
        const newSortedBy = val !== this.state.orderBy ? 'asc' : sortedBy === 'asc' ? 'desc' : 'asc';
        this.setState({ orderBy: val, sortedBy: newSortedBy }, () => this.__fetchData(false));
    };

    handleOpen = (row) => {
        this.setState({
            showDialog: true,
            idDelete: row.idProduct,
            currDelete: row.name,
            active: row.isActive,
        });
    };

    handleClose = () => this.setState({ showDialog: false });

    handleChange (e, prop){
        this.setState({ [prop]: e.target.value });
    };

    handleCat = (e, prop) => {
        const value = e.target.value;
        this.setState({ [prop]: value }, () => {
            this.__fetchData(true);
            const { cat, sub, productSegment } = this.state;
    
            let url = '/products';
            const queryParams = [];
            if (cat) queryParams.push(`cat=${encodeURIComponent(cat)}`);
            if (sub) queryParams.push(`sub=${encodeURIComponent(sub)}`);
            if (productSegment) queryParams.push(`productSegment=${encodeURIComponent(productSegment)}`);
    
            if (queryParams.length > 0) url += `?${queryParams.join('&')}`;
            window.location.replace(url);
        });
    };

    handleDelete = () => {
        if (!this.state.idDelete) return;

        Api.delete('/product', { listId: [this.state.idDelete] })
            .then(() => {
                this.setState({ showDialog: false });
                this.showMessage(true, 'Produk berhasil dihapus');
                this.__fetchData(true);
            })
            .catch(() => this.setState({ showDialog: false }));
    };

    handleActive = () => {
        if (this.state.idDelete) {
            let params = { id: this.state.idDelete, status: true };
            Api.put('/product/update-status', params).then(resp => {
                this.showMessage(true, 'Produk berhasil kembali aktif');
                this.__fetchData(false);
            }).finally(() => {
                this.setState({ showDialog: false });
            });
        }
    }

    handleExport = ()  => {
        this.setState({ loadingButton: true });
        Api.get('/product/export/excel','blob').then(res=>{
            res.blob().then(resp => {
                let url = window.URL.createObjectURL(resp);
                let a = document.createElement('a');
                a.href = url;
                a.download = 'products.xlsx';
                a.click();
            });
            this.setState({ loadingButton: false });
        });
    };

    render() {
        const { rows, loading, loadingButton, isManage, showDialog, cat, sub, searchBy, orderBy, sortedBy } = this.state;
        return (
            <div className="row main-content">
                <div className="col-12">
                    <h1 className="page-title">Produk</h1>
                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item"><Link to="/">Home</Link></li>
                            <li className="breadcrumb-item active" aria-current="page">Produk</li>
                        </ol>
                    </nav>
                </div>
                <div className="col-12">
                    <div className="table-wrapper">
                        <div className="row align-items-center content-title">
                            <div className="col-6">
                                <h2 className="mb-0">Daftar Produk</h2>
                            </div>
                            <div className="col-6 text-right">
                                <Button
                                    variant="contained"
                                    color="primary"
                                    className="mr-2"
                                    onClick={() => this.handleExport(true)}
                                    disabled={loadingButton}
                                >
                                    <i className="fas fa-file-excel mr-2"></i>
                                    Export {loadingButton && <i className="fa fa-spinner fa-spin"></i>}
                                </Button>
                                {isManage && (
                                    <Button variant="contained" color="secondary" onClick={() => this.handleGo('/products/add')}>
                                        <i className="fas fa-plus mr-2"></i>Buat Produk
                                    </Button>
                                )}
                            </div>
                        </div>
                        <div className="row align-items-center justify-content-between content-filter">
                            <div className="col-md-3 mb-2 mb-md-0">
                                <TextField
                                    id="input-with-icon-textfield"
                                    variant="outlined"
                                    className="search-field"
                                    onChange={(e) => this.handleChange(e, 'searchBy')}
                                    onKeyDown={this.handleKeyDown}
                                    onBlur={this.handleSearch}
                                    placeholder="Cari produk..."
                                    InputProps={{
                                        endAdornment: (
                                            <InputAdornment position="start">
                                                <IconButton aria-label="Search click" onClick={this.handleSearch}><i className="fas fa-search"> </i></IconButton>
                                            </InputAdornment>
                                        ),
                                    }}
                                    fullWidth
                                />
                            </div>
                            <div className="col-md-3 col-lg-3 text-md-right ml-auto">
                                <TextField
                                    id="productSegment"
                                    name="productSegment"
                                    variant="outlined"
                                    label="Tipe Harga Produk"
                                    onChange={(e) => this.handleCat(e, 'productSegment')}
                                    value={this.state.productSegment}
                                    fullWidth
                                    select
                                >
                                    <MenuItem value=''>Tanpa Filter</MenuItem>
                                    <MenuItem value='ALL'>Semua</MenuItem>
                                    <MenuItem value='INDIVIDU'>Individu</MenuItem>
                                    <MenuItem value='CORPORATE'>Corporate</MenuItem>
                                </TextField>
                            </div>
                            <div className="col-md-3 col-lg-3 text-md-right ml-auto">
                                <TextField
                                    id="cat"
                                    name="cat"
                                    variant="outlined"
                                    label="Kategori"
                                    onChange={(e) => this.handleCat(e, 'cat')}
                                    value={this.state.cat}
                                    fullWidth
                                    select
                                >
                                    <MenuItem value=''>Semua</MenuItem>
                                    {this.state.categories.map(option => (<MenuItem key={option.id} value={option.id}>{option.name}</MenuItem>))}
                                </TextField>
                            </div>
                            <div className="col-md-3 col-lg-3 text-md-right">
                                <TextField
                                    variant="outlined"
                                    select
                                    id="sub"
                                    name="sub"
                                    label="Tag"
                                    onChange={(e) => this.handleCat(e, 'sub')}
                                    value={sub}
                                    fullWidth
                                >
                                    <MenuItem value="">Semua</MenuItem>
                                    {this.state.subcategories.map((option) => (<MenuItem key={option.id} value={option.id}>{option.name}</MenuItem>))}
                                </TextField>
                            </div>
                        </div>
                        <div className="table-list row">
                            <Table size="small">
                                <TableHead>
                                    <TableRow>
                                        <TableCell className="clickable" onClick={() => this.handleSort('productName')}>
                                            Nama Produk
                                            {orderBy === 'productName' && (<span className="icon-sort">{sortedBy === 'asc' ? <i className="fas fa-sort-up"></i> : <i className="fas fa-sort-down"></i>}</span>)}
                                        </TableCell>
                                        <TableCell className="clickable" onClick={() => this.handleSort('sku')}>
                                            SKU
                                            {orderBy === 'sku' && (<span className="icon-sort">{sortedBy === 'asc' ? <i className="fas fa-sort-up"></i> : <i className="fas fa-sort-down"></i>}</span>)}
                                        </TableCell>
                                        <TableCell className="clickable" onClick={() => this.handleSort('stock')}>
                                            Stock
                                            {orderBy === 'stock' && (<span className="icon-sort">{sortedBy === 'asc' ? <i className="fas fa-sort-up"></i> : <i className="fas fa-sort-down"></i>}</span>)}
                                        </TableCell>
                                        <TableCell className="clickable" onClick={() => this.handleSort('regularPrice')}>
                                            Harga
                                            {orderBy === 'regularPrice' && (<span className="icon-sort">{sortedBy === 'asc' ? <i className="fas fa-sort-up"></i> : <i className="fas fa-sort-down"></i>}</span>)}
                                        </TableCell>
                                        <TableCell>Kategori</TableCell>
                                        <TableCell style={{ minWidth: 75 }}>Type</TableCell>
                                        <TableCell>Rating</TableCell>
                                        <TableCell>Status</TableCell>
                                        <TableCell style={{ minWidth: 100 }}>Action</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {loading ? (
                                        <TableRow>
                                            <TableCell colSpan={9} align="center" className="py-5"><CircularProgress color="primary" /></TableCell>
                                        </TableRow>
                                    ) : rows.length === 0 ? (
                                        <TableRow style={{ height: 33 * this.state.perPage }}>
                                            <TableCell colSpan={9} style={{ textAlign: 'center' }}>Produk kosong</TableCell>
                                        </TableRow>
                                    ) : (
                                        rows.map((row) => (
                                            <TableRow key={row.id} selected={row.selected}>
                                                <TableCell>
                                                    <div className="d-flex">
                                                        <img src={row.image || image} alt="avatar" className="img-product mr-2" /><span>{row.name || ''}</span>
                                                    </div>
                                                </TableCell>
                                                <TableCell>{row.sku || ''}</TableCell>
                                                <TableCell>{row.stock}<strong className={row.stock > 0 ? 'd-block in' : 'd-block out'}>{row.stock > 0 ? 'in stock' : 'out of stock'}</strong></TableCell>
                                                <TableCell>
                                                    {row.isSale ? (
                                                        <>
                                                            <p className="discount-price">
                                                                Rp <NumberFormat thousandSeparator value={row.price} displayType="text" renderText={(value) => <span>{value}</span>} />
                                                            </p>
                                                            <p>
                                                                Rp <NumberFormat thousandSeparator value={row.priceSale} displayType="text" renderText={(value) => <span>{value}</span>} />
                                                            </p>
                                                        </>
                                                    ) : (
                                                        <p>
                                                            Rp <NumberFormat thousandSeparator value={row.price} displayType="text" renderText={(value) => <span>{value}</span>} />
                                                        </p>
                                                    )}
                                                </TableCell>
                                                <TableCell>{row.category || ''}<span className="label-cat">{row.sub || ''}</span></TableCell>
                                                <TableCell>{row.productType || ''}</TableCell>
                                                <TableCell>{row.rating || '-'}</TableCell>
                                                <TableCell>{row.isActive ? (<i className="fas fa-check-circle icon-green"></i>) : (<i className="fas fa-times-circle icon-red"></i>)}</TableCell>
                                                <TableCell className="action-menu">
                                                    <button className="btn-icon"><i className="fas fa-ellipsis-v"></i></button>
                                                    <div className="action-wrap">
                                                        <Link to={`/products/edit/${row.idProduct}`} className="btn-icon mb-2">
                                                            <i className="fas fa-pencil-alt"></i> Ubah
                                                        </Link>
                                                        {isManage && (
                                                            <button className="btn-icon" onClick={() => this.handleOpen(row)}>
                                                                {row.isActive ? (<span><i className="fas fa-times-circle"></i> Deactive</span>) : (<span><i className="fas fa-check-circle"></i> Active</span>)}
                                                            </button>
                                                        )}
                                                    </div>
                                                </TableCell>
                                            </TableRow>
                                        ))
                                    )}
                                </TableBody>
                            </Table>
                        </div>
                        <TablePagination
                            rowsPerPageOptions={[20]}
                            component="div"
                            count={this.state.total}
                            rowsPerPage={this.state.perPage}
                            page={this.state.currentPageTable}
                            backIconButtonProps={{ 'aria-label': 'previous page' }}
                            nextIconButtonProps={{ 'aria-label': 'next page' }}
                            onChangePage={this.handleChangePage}
                            onChangeRowsPerPage={this.handleChangeRowsPerPage}
                            ActionsComponent={TablePaginationActions}
                        />
                    </div>
                    <Dialog
                        maxWidth="sm"
                        fullWidth
                        open={showDialog}
                        onClose={this.handleClose}
                        aria-labelledby="form-dialog-title"
                    >
                        <DialogTitle id="form-dialog-title">KONFIRMASI</DialogTitle>
                        <DialogContent>
                            <p>Apakah anda yakin akan mengubah status produk ini ? (<strong>{this.state.currDelete}</strong>)</p>
                        </DialogContent>
                        <DialogActions>
                            <button className="btn btn-blue-trans" onClick={this.handleClose}>Batal</button>
                            {this.state.active ? (
                                <button className="btn btn-blue" onClick={this.handleDelete}>Deactive</button>
                            ) : (
                                <button className="btn btn-blue" onClick={this.handleActive}>Active</button>
                            )}
                        </DialogActions>
                    </Dialog>
                    <ToastContainer />
                </div>
            </div>
        );
    }
}

export default Products;